// extracted by mini-css-extract-plugin
export default {"container":"SidebarProfilePicture_container__XDXb0","picture":"SidebarProfilePicture_picture__oJMWH"};